const ASSET_DIRECTORY = 'assets';

export const mapAssetsBaseUrl = (bucketName: string): string =>
  `https://s3.amazonaws.com/${bucketName}/${ASSET_DIRECTORY}`;
